import { FormTextField, FormTextFieldProps } from "@bvhi/ui-base";
import { useTranslation } from "react-i18next";

interface Props extends Omit<FormTextFieldProps, "name"> {
  name?: string;
}

export const FormTextFieldUsernameConfirmation = ({ name = "usernameConfirmation", label, placeholder, fullWidth, ...props }: Props) => {
  const { t } = useTranslation(["common"]);

  return (
    <FormTextField
      fullWidth={fullWidth ?? true}
      label={label ?? t("common:form.text.field.username.confirm.label")}
      name={name}
      placeholder={placeholder ?? t("common:form.text.field.username.confirm.placeholder")}
      {...props}
    />
  );
};
